export default __webpack_public_path__ + "static/media/profile.0cdb570c.jpg";